export interface Invoice {
  id: number;
  qr_data: string;
  nif_emitente?: string;
  nif_adquirente?: string;
  valor?: number;
  data_emissao?: string;
  numero_fatura?: string;
  hash_validacao?: string;
  categoria: InvoiceCategory;
  tipo?: InvoiceTipo;
  mes_relatorio?: number;
  descricao?: string;
  photo_url?: string;
  created_at?: string;
  updated_at?: string;
  // Company names (from LEFT JOIN)
  emitente_nome?: string;
  emitente_nome_curto?: string;
  adquirente_nome?: string;
  adquirente_nome_curto?: string;
}

export type InvoiceCategory =
  | "regular"
  | "a_faturar"
  | "despesa"
  | "despesa_a_faturar";

export type InvoiceTipo =
  | "refeicao"
  | "representacao"
  | "uber"
  | "tap"
  | "alojamento"
  | "ctt"
  | "mat_escritorio"
  | "tesla"
  | "via_verde"
  | "cafe"
  | "electricidade"
  | "festa_1_ano"
  | "aws"
  | "manutencao"
  | "ofertas";

export const TIPO_DISPLAY_NAMES: Record<InvoiceTipo, string> = {
  refeicao: "Refeição",
  representacao: "Representação",
  uber: "Uber",
  tap: "TAP",
  alojamento: "Alojamento",
  ctt: "CTT",
  mat_escritorio: "Material Escritório",
  tesla: "Tesla",
  via_verde: "Via Verde",
  cafe: "Café",
  electricidade: "Electricidade",
  festa_1_ano: "Festa 1º Ano",
  aws: "AWS",
  manutencao: "Manutenção",
  ofertas: "Ofertas",
};

export interface InvoiceFilters {
  categoria?: InvoiceCategory;
  tipo?: InvoiceTipo;
  nif_emitente?: string;
  nif_adquirente?: string;
  id_min?: number;
  mes?: string;
  ano?: number;
  data_inicio?: string;
  data_fim?: string;
  valor_min?: number;
  valor_max?: number;
  sem_foto?: boolean;
  page?: number;
  limit?: number;
  sort_order?: "ASC" | "DESC";
  sort_by?: "id" | "data_emissao" | "valor";
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message: string;
  pagination?: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface InvoiceSummary {
  categoria: InvoiceCategory;
  total_faturas: number;
  valor_total: number;
  valor_medio: number;
  primeira_fatura: string;
  ultima_fatura: string;
}

export const CATEGORY_LABELS: Record<InvoiceCategory, string> = {
  regular: "Regular",
  a_faturar: "A Faturar",
  despesa: "Despesa",
  despesa_a_faturar: "Despesa A Faturar",
};

export const CATEGORY_COLORS: Record<InvoiceCategory, string> = {
  regular: "#1976d2",
  a_faturar: "#ed6c02",
  despesa: "#d32f2f",
  despesa_a_faturar: "#7b1fa2",
};
